import { render, staticRenderFns } from "./dashboardcarousel.vue?vue&type=template&id=30790428&"
import script from "./dashboardcarousel.vue?vue&type=script&lang=js&"
export * from "./dashboardcarousel.vue?vue&type=script&lang=js&"
import style0 from "./dashboardcarousel.vue?vue&type=style&index=0&id=30790428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports